
export default function TeamSection() {
  const team = [
    {
      name: 'Sarah Johnson',
      role: 'Founder & CEO',
      image: 'https://readdy.ai/api/search-image?query=Professional%20businesswoman%20CEO%20headshot%2C%20confident%20smile%2C%20business%20attire%2C%20modern%20office%20background%2C%20executive%20portrait%20photography%2C%20professional%20lighting&width=400&height=400&seq=team-ceo&orientation=squarish',
      bio: 'Sarah founded Cofunnels with a vision to help businesses maximize their online potential. With 8+ years in digital marketing, she leads our strategy and client relationships.'
    },
    {
      name: 'Michael Chen',
      role: 'Lead Funnel Designer',
      image: 'https://readdy.ai/api/search-image?query=Professional%20male%20designer%20headshot%2C%20creative%20professional%2C%20casual%20business%20attire%2C%20modern%20workspace%20background%2C%20friendly%20approachable%20expression&width=400&height=400&seq=team-designer&orientation=squarish',
      bio: 'Michael brings artistic vision to conversion science. His designs have helped increase conversion rates by an average of 300% across our client portfolio.'
    },
    {
      name: 'Emily Rodriguez',
      role: 'Conversion Specialist',
      image: 'https://readdy.ai/api/search-image?query=Professional%20businesswoman%20analyst%20headshot%2C%20data%20specialist%2C%20modern%20office%20setting%2C%20confident%20professional%20appearance%2C%20business%20casual%20attire&width=400&height=400&seq=team-analyst&orientation=squarish',
      bio: 'Emily is our data-driven optimization expert. She analyzes every metric to ensure our funnels perform at their absolute best for maximum ROI.'
    },
    {
      name: 'David Thompson',
      role: 'Technical Lead',
      image: 'https://readdy.ai/api/search-image?query=Professional%20male%20developer%20headshot%2C%20technical%20expert%2C%20modern%20office%20background%2C%20confident%20smile%2C%20business%20casual%20attire%2C%20tech%20professional&width=400&height=400&seq=team-tech&orientation=squarish',
      bio: 'David ensures all our funnels are technically sound, fast-loading, and mobile-optimized. His expertise in ClickFunnels and GoHighLevel is unmatched.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Meet Our Team
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            The talented professionals behind your success
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {team.map((member, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="aspect-square overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h3>
                <p className="text-blue-600 font-medium mb-3">{member.role}</p>
                <p className="text-gray-600 text-sm leading-relaxed">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">Want to Join Our Team?</h3>
            <p className="text-blue-100 mb-6">
              We're always looking for talented individuals who share our passion for helping businesses succeed.
            </p>
            <a 
              href="mailto:careers@cofunnels.com" 
              className="inline-flex items-center bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-mail-line mr-2"></i>
              View Open Positions
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}